/* eslint-disable react/no-danger */
import { UIHeading4, Button, UIText1, Image } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './OffersEmptyState.css';
// @ts-expect-error TODO: исправить импорт картинок
import OffersImage from './assets/offers.png';
// @ts-expect-error TODO: исправить импорт картинок
import WarningImage from './assets/warning.png';

interface IProps {
  isWithError: boolean;
  onLoad: () => void;
}

export const OffersEmptyState = ({ isWithError, onLoad }: IProps) => {
  const image = isWithError ? WarningImage : OffersImage;
  const title = isWithError ? 'Объявления не загрузились' : 'У вас нет активных объявлений';
  const text = isWithError ? (
    <UIText1 color="gray60_100">
      Попробуйте ещё раз, <br /> уже должно работать
    </UIText1>
  ) : (
    <UIText1 color="gray60_100">
      Если хотите поделиться объявлением <br /> из архива, сначала восстановите его
    </UIText1>
  );

  return (
    <div className={style['container']}>
      <div className={style['image']}>
        <Image src={image} />
      </div>
      <UIHeading4>{title}</UIHeading4>
      <div className={style['text']}> {text} </div>
      {isWithError && (
        <Button size="M" theme="fill_primary" onClick={onLoad}>
          Повторить
        </Button>
      )}
    </div>
  );
};
